// extracted by mini-css-extract-plugin
module.exports = {"rainbow":"About_rainbow__PoY9p","team":"About_team__wrv2k","hero":"About_hero__RY5Ym"};